/**
 * debugState — live runtime data written every frame by AvatarModel/GraphEvaluator.
 * Read by BlueprintEditor (polled every 100ms) to show visual feedback on nodes.
 *
 * Never triggers React re-renders directly — the polling useEffect does that.
 */
export const debugState = {
  clipWeights:    {},  // { clipName: number }       — merged clip weights (0-1)
  bodyWeights:    {},  // { clipName: number }       — body-only clip weights
  faceWeights:    {},  // { clipName: number }       — face-only clip weights
  smCurrentState: {},  // { smNodeId: stateId|null }  — active state per SM
  ruleResults:    {},  // { 'smNodeId::edgeId': bool } — rule eval per transition
  clipTimings:    {},  // { clipName: { time, duration, remaining, ratio } } — the heaviest player of each clip
  smClipTimings:  {},  // { smNodeId: { stateId, time, duration, remaining, ratio } } — the CURRENT state's own Play Clip player, what Time Remaining / Ratio rules read (stateId null when it has none)
  eventData:      {},  // { [eventType]: lastPayload } — last fired payload per event
  eventFireCounts: {}, // { [eventType]: number }      — total fires per event type (Wave 2B: locks onConstruct's once-post-boot + refire-on-edit contract)
  nodeLastFired:  {},  // { [nodeId]: Date.now() }    — timestamp when exec last hit the node
  eyeFollow:      { weight: 0, yaw: 0, pitch: 0 },  // eyeFollowRuntime's smoothed aim (rad) — declared, so the writer mutates fields instead of allocating a fresh object each frame
  look:           { state: 'Inactive', mode: 'inactive', holding: false }, // lookRuntime's Attention state, for the Look node's badge (mutated, not reallocated)

  tick:           0,   // bumped by GraphEvaluator.applyWeights — editors poll against this to skip redundant React updates
}
